import { useState } from 'react';
import { WarningCircleIcon } from '@phosphor-icons/react';

const useEditValidation = () => {
    const [validationErrors, setValidationErrors] = useState({});
    const [historyValidationError, setHistoryValidationError] = useState('');

    const validateItem = (item) => {
        const errors = {};
        if (!item.classification || item.classification.trim() === '') {
            errors.classification = <p className='form-error'>Choose a class</p>;
        }
        if (!item.name || item.name.trim().length === 0) {
            errors.name = <p className='form-error'>Enter a name</p>;
        }
        if (!item.valuation || item.valuation === 0 || isNaN(item.valuation)) {
            errors.valuation = <p className='form-error'>Enter a value</p>;
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateHistoryEntry = (date, value, existingHistory, excludeIndex = null) => {
        if (!value || value === '') {
            setHistoryValidationError(<p className='form-error'>Enter a value</p>);
            return false;
        }
        if (!date || date === '') {
            setHistoryValidationError(<p className='form-error'>Select a date</p>);
            return false;
        }
        const today = new Date().toISOString().split('T')[0];
        if (date > today) {
            setHistoryValidationError(<p className='form-error'>Date cannot be in the future</p>);
            return false;
        }
        const existingDates = (existingHistory || [])
            .filter((_, i) => i !== excludeIndex)
            .map(r => r.date);
        if (existingDates.includes(date)) {
            setHistoryValidationError(<p className='form-error'>Entry for this date already exists</p>);
            return false;
        }
        setHistoryValidationError('');
        return true;
    };

    const clearErrors = () => setValidationErrors({});
    const clearHistoryError = () => setHistoryValidationError('');

    return {
        validationErrors,
        historyValidationError,
        validateItem,
        validateHistoryEntry,
        clearErrors,
        clearHistoryError
    };
};

export default useEditValidation;
